<script setup>
import { ref, computed,watch } from 'vue';
import { useQuasar, QVideo } from 'quasar';
const $q = useQuasar();
const darkMode = ref($q.dark.isActive);

watch(() => $q.dark.isActive, (newVal) => {
    darkMode.value = newVal;
});
const isLargeScreen = computed(() => $q.screen.gt.xs);
const videoVisible = ref(false);


useHead({
  title: 'OnSight Optical Brings Dispensing Directly to MDs',
  meta: [
    { name: 'description', content: 'Article from Vision Monday about the founding of OnSight Optical.' }
  ]
})
</script>

<template>
  <div class="row justify-center q-mt-lg q-mb-lg" style="margin-top: 40px;">
    <div class="col-11 col-md-6">
      <div :class="['text-h3 text-left', darkMode ? 'text-grey-5' : 'text-brand']"><strong>OnSight Optical Brings Dispensing Directly to MDs</strong>
      </div>
      <div :class="['text-h3 text-left', darkMode ? 'text-grey-5' : 'text-brand']">By Cathy Ciccolella</div>
      <div :class="['text-h3 text-left', darkMode ? 'text-grey-5' : 'text-brand']">Vision Monday - September 18, 1995</div>
      <br>
      <div :class="darkMode ? 'text-grey-5' : 'text-brand'">
        <p style="font-size: 20px;">FLORIDA OPHTHALMOLOGISTS looking for a quick entry into eyewear dispensing now have a new option: OnSight
          Optical, launched last spring, has begun opening dispensaries in ophthalmology practices in the state’s Tampa
          Bay region.</p>
        <p style="font-size: 20px;"> And Florida is only the beginning, says OnSight Optical president Mike Bernstein and vice
          president/controller Mike Shane. The two are already talking to MDs in other areas of Florida, and say they
          have been approached by others in the optical industry about taking the concept to additional markets
          nationwide.</p>
        <p style="font-size: 20px;"> “Our goal is to install optical centers in established ophthalmology practices with large patient bases,”
          Bernstein explains. “We construct an optical department, stock it using a planogrammed merchandising strategy,
          with frames selected to support the doctor’s practice, and recruit experienced licensed opticians to manage
          the department.”</p>
        <p style="font-size: 20px;"> The opticians are employees of the practice, not of OnSight Optical; if desired by the ophthalmologist,
          Bernstein and Shane will also cross-train current employees of the practice to help out in the dispensary.
          “We’ll train people from the practice to dispense, but we feel an experienced optician is a must to manage the
          dispensary,” Bernstein notes. </p>
        <p style="font-size: 20px;"> OnSight Optical’s first two locations opened last month at Pasco Eye Institute, headed by Frederick Hauber
          MD, and at Patrick Rowan MD’s Rowan Eye Center, both in New Port Richey, Fla. Each dispensary was built inside
          the ophthalmology practice’s building, using existing space; Shane, whose background is in finance and
          construction, helps determine the best location for the optical center within the office and oversees the
          renovations.</p>
        <p style="font-size: 20px;"> The dispensaries each stock about 600 frames, primarily men’s and women’s styles in plastic and metal,
          according to a planogram developed by OnSight Optical.</p>
        <p style="font-size: 20px;"> The dispensary prototypes were designed by Pieter Oschmann Associates, a local design firm. Oschmann
          designed the original Visionworks stores for former owner Jack Eckerd Corp.; Bernstein launched the
          Visionworks chain for Eckerd in the mid-1980s.</p>
        <p style="font-size: 20px;"> OnSight Optical handles the buying for the dispensaries, using 10 frame vendors, and restocks as frames are
          sold. “Our frame inventory is customized to the needs of a particular practice’s patient load,” notes Shane.
          Retail frame prices range from $29 to $359.</p>
        <p style="font-size: 20px;"> “The statement we’re trying to make is that patients can go to an ophthalmologist’s office and get
          reasonable prices on eyewear,” Bernstein tells Vision Monday. “Our lenses are also priced to be very
          competitive, below the large chains. We mean to compete in the marketplace with everyone on style and price.”
        </p>
        <p style="font-size: 20px;"> Next month, as Florida’s winter “season” begins to swell the area’s population, OnSight will begin
          advertising “to draw in more patients for exams and eyeglasses,” Bernstein says. Until then, the company has
          been distributing flyers containing $30-off coupons to patients of the two practices in which it has
          dispensaries.</p>
        <p style="font-size: 20px;"> “Having an optical center can improve a practice’s patient flow,” Bernstein stresses. “Also, besides being a
          revenue producer, the optical center gives the doctor control over the final product the patient puts on to
          see with.”</p>
        <p style="font-size: 20px;"> The dispensing requirements of many managed vision-care programs are another incentive for MDs to add
          dispensaries, he says. Dr. Rowan, for example, tells Vision Monday, “We’re anticipating getting into managed
          care, which requires a practice to provide a complete gamut of services. We’re excited about the new optical
          center, and the patients love it.”</p>
        <p style="font-size: 20px;"> (For practices not yet involved in managed care, OnSight Optical will evaluate various programs and offer
          ophthalmologists recommendations on which to join.)</p>


      </div>

    </div>
  </div>


</template>
